var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down_Arrow_-_Small",
    "data-name": "Down Arrow - Small",
    d: "M4.106,1.789a1,1,0,0,1,1.789,0L9.276,8.553A1,1,0,0,1,8.382,10H1.618A1,1,0,0,1,.724,8.553Z",
    transform: "translate(10 10) rotate(180)",
    fill: "#ec3717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDownArrow);
export default __webpack_public_path__ + "static/media/small-down-arrow.d5cb9ef90c5b8da2b203c3968d6da9f7.svg";
export { ForwardRef as ReactComponent };